import React from 'react';
import AddIcon from '@atlaskit/icon/glyph/add';
import { LoadingButton } from '@atlaskit/button';
import { CompanyName } from './common';

interface Props {
  onAddClick: () => void;
  isLoading?: boolean;
}

export const CustomerEmpty = ({ onAddClick, isLoading }: Props) => {
  return (
    <div className="ppc-customer-empty">
      <div className="flex justify-space-between align-center">
        <CompanyName />
        <LoadingButton
          iconBefore={<AddIcon label="add-customer" />}
          onClick={onAddClick}
          isLoading={isLoading}
          testId="add-company-plus-btn"
        />
      </div>
    </div>
  );
};
